import { render } from "./FormCargosModal.vue?vue&type=template&id=5c72434b&ts=true"
import script from "./FormCargosModal.vue?vue&type=script&lang=ts"
export * from "./FormCargosModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__